import React, { Component } from 'react';
import { QuizDetailStore } from 'stores';
import { QuizDetailActions } from 'actions';
import { mixin, RefluxMixin } from 'Util';
import Quizzes from './Quizzes';

export default class TasksContainer extends mixin(RefluxMixin, Component) {
  componentDidMount() {
    const { courseId, userId, taskId } = this.props.params;
    QuizDetailActions.start({
      courseId,
      userId,
      taskId
    });
  }

  listenToStores() {
    this.listenToStore(QuizDetailStore);
  }

  render() {
    return <Quizzes {...this.state} />;
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/QuizContainer.js